import React, { lazy, Suspense, useState, useEffect } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import LoadingIndicator from '../LoadingIndicator';
var VideoPlayerLazy = lazy(function () {
    /* webpackChunkName: "misc" */
    return import('@wix/video-player-react/dist/src/wrapper/wrapper');
});
// There's an issue with playable and how we use it in that, when
// we take the deviation page full screen, playable hears that same
// fullscreenchange event and makes itself fullscreen and, for reasons
// involving css, the player is 0x0 in dimension
// This playable plugin module stops that fullscreenchange listener
// but! also removes the ability of the video-player to go fullscreen
// itself
var FullScreenModule = /** @class */ (function () {
    function FullScreenModule() {
    }
    Object.defineProperty(FullScreenModule.prototype, "isEnabled", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    FullScreenModule.moduleName = 'fullScreenManager';
    return FullScreenModule;
}());
export var VideoPlayer = function (_a) {
    var width = _a.width, height = _a.height, src = _a.src, className = _a.className, autoPlay = _a.autoPlay, loadingCover = _a.loadingCover, fillAllSpace = _a.fillAllSpace, onInit = _a.onInit;
    var _b = useState(false), mounted = _b[0], setMounted = _b[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    return (React.createElement(ErrorBoundary, null,
        mounted && (React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, { coverMode: true }) },
            React.createElement(VideoPlayerLazy, { className: className, src: src, autoPlay: autoPlay, fillAllSpace: fillAllSpace, loadingCover: loadingCover, onInit: onInit, width: width, height: height, on: {}, modules: { fullScreenManager: FullScreenModule } }))),
        React.createElement("noscript", null,
            React.createElement("video", { width: width || 640, height: height || 480, controls: true, src: src }))));
};
VideoPlayer.displayName = 'VideoPlayer';
//# sourceMappingURL=LoadableVideoPlayer.js.map